import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  PasswordInput,
  useNotify,
  useRedirect,
  useDataProvider,
  usePermissions,
} from "react-admin";

const UserCreate = () => {
  const { permissions = [] } = usePermissions();
  const notify = useNotify();
  const redirect = useRedirect();
  const dataProvider = useDataProvider();
  const handleSubmit = async (values) => {
    try {
      await dataProvider.create("users", {
        data: values,
      });
      notify("User created successfully 🎉", {
        type: "success",
      });
      redirect("/users");
    } catch (error) {
      notify(error.message || "Error creating user", {
        type: "error",
      });
    }
  };

  // Allow user.create OR super-admin (*)
  if (!(permissions.includes("users.create") || permissions.includes("users.*") || permissions.includes("*"))) {
    return null;
  }

  return (
    <Create title="Create User">
      <SimpleForm onSubmit={handleSubmit}>
        <TextInput source="name" required />
        <TextInput source="email" type="email" required />
       

       
        

       
      </SimpleForm>
    </Create>
  );
};

export default UserCreate;
